import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool } from '../../../../tool'
import { dynamicWizTableColumns, dynamicWizModalFormColumns } from './columns'
import './rule.less'

let { WizContainer } = framework_tool
let { WizSpin, WizRow, WizCol, WizButton, WizAlert, WizModalForm, WizTable, WizInputNumber } = component_tool
class PracticeRule extends WizContainer {

    componentName = 'PracticeRule'

    constructor(props) {
        super(props)
        this.state = {
            practiceId: props.practiceId,
            status: 0,
            tempId: props.tempId,
            dynamicWizTableInfo: [],
            categoryTabelForm: [],//分类tabel中的数据
            categoryModalFormVisible: false,
            practiceInfo: { id: props.practiceId },
            resetTime: new Date().getTime()
        }
    }

    _componentDidMount() {
        let { practiceId } = this.state
        this._getRuleList(practiceId)
        this._getPracticeInfo(practiceId)
    }

    _getRuleList(practiceId) {
        this.doAction({
            path: 'practice/getRuleInfoById',
            payload: {
                key: 'getRuleInfoById',
                apiParams: { practiceId: practiceId }
            }
        })

    }
    _getPracticeInfo(practiceId) {
        this.doAction({
            path: 'practice/getBaseInfoById',
            payload: {
                key: 'getBaseInfoById',
                apiParams: { id: practiceId }
            }
        })
    }

    _createRule(values) {
        this.doAction({
            path: 'practice/addRule',
            payload: {
                key: 'createRule_' + this.state.practiceId,
                apiParams: { practiceId: this.state.practiceId, ...values }
            }
        })
    }

    _updateRule(values) {
        this.doAction({
            path: 'practice/addRule',
            payload: {
                key: 'updateRule_' + this.state.practiceId,
                apiParams: { practiceId: this.state.practiceId, ...values }
            }
        })
    }

    _saveAndNext = () => {
        this.setState({ status: 1 }, () => {
            let values = this._fitterValues()
            if (this.state.type === 'update') {
                this._updateRule(values)
            } else {
                this._createRule(values)
            }
        })
    }

    _saveAndBack = () => {
        this.setState({ status: 2 }, () => {
            let values = this._fitterValues()
            if (this.state.type === 'update') {
                this._updateRule(values)
            } else {
                this._createRule(values)
            }
        })
    }

    _onReset = () => {
        let { practiceId } = this.state
        this._getRuleList(practiceId)
        this._getPracticeInfo(practiceId)
        this.setState({ resetTime: new Date().getTime() })
    }

    _fitterValues() {
        let { practiceId, categoryTabelForm, questionAllNum, questionNum } = this.state
        if (!questionNum) {
            wizNotice.error('每日抽题数量不能为空')
            return false;
        }
        if (questionNum > questionAllNum || questionNum > 120) {
            wizNotice.error('每日抽题数量必须小于等于试题总数，且不能大于120')
            return false;
        }
        let list = []

        if (Array.isArray(categoryTabelForm) && categoryTabelForm.length) {
            categoryTabelForm.forEach(item => {
                let ruleInfo = {
                    id: item.id ? item.id : null,
                    categoryId: item.categoryIds,
                    type: item.type,
                    difficulty: item.difficulty
                }
                list.push(ruleInfo)
            })
        } else {
            wizNotice.error('习题设计不能为空')
            return false;
        }

        let distinctList = new Set(list.map(i=> `${i.categoryId}-${i.type}-${i.difficulty}`))
        if (distinctList.size < list.length) {
            wizNotice.error('同一题目分类不能存在相同的题型')
            return false;
        }
        let cmd = { practiceId: practiceId, questionNum: questionNum, list: list }
        return cmd;
    }

    propsAndStateOnChange = {
        createRule: this._createRuleOnChange.bind(this),
        updateRule: this._updateRuleOnChange.bind(this),
        practiceRule: this._ruleInfoOnChange.bind(this),
        practiceInfo: this._practiceInfoOnChange.bind(this),
    }

    _practiceInfoOnChange(nextProps, nextState) {
        if (nextProps.practiceInfo.code === 1) {
            nextState.practiceInfo = nextProps.practiceInfo.data
            let { questionNum } = nextProps.practiceInfo.data
            nextState.questionNum = questionNum
        }
        return true
    }

    _ruleInfoOnChange(nextProps, nextState) {
        if (nextProps.practiceRule.code === 1) {
            let data = nextProps.practiceRule.data
            let ruleList = []
            let questionAllNum = 0
            if (Array.isArray(data) && data.length) {
                data.forEach(item => {
                    let ruleInfo = {
                        id: item.id,
                        practiceId: item.practiceId,
                        categoryIds: item.categoryId,
                        questionCategory: item.categoryId,
                        questionCategoryTitle: item.categoryName,
                        type: item.type,
                        typeTitle: this._getValue('type', item.type),
                        difficulty: item.difficulty,
                        difficultyTitle: this._getValue('difficulty', item.difficulty),
                        size: item.size,
                    }
                    ruleList.push(ruleInfo)
                })
                const sizes = data.map(item => item.size);
                questionAllNum = sizes.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            }
            nextState.categoryTabelForm = ruleList
            nextState.questionAllNum = questionAllNum
        }
        return true
    }


    _createRuleOnChange(nextProps, nextState) {
        if (nextProps.createRule.code === 1) {
            if (this.state.status === 1) {
                this.props.nextFunc && this.props.nextFunc()
            } else if (this.state.status === 2) {
                this.props.backFunc && this.props.backFunc()
            }
        }
        return true
    }

    _updateRuleOnChange(nextProps, nextState) {
        if (nextProps.updateRule.code === 1) {
            if (this.state.status === 1) {
                this.props.nextFunc && this.props.nextFunc()
            } else if (this.state.status === 2) {
                this.props.backFunc && this.props.backFunc()
            }
        } else {
            wizNotice.error(nextProps.updateRule.msg)
            return false;
        }
        return true
    }

    _prev = () => {
        this.props.prevFunc && this.props.prevFunc()
    }

    //题目类型对应
    _getValue(type, key) {
        const values = {
            type: {
                0: '单选题',
                1: '多选题',
                2: '判断题',
            },
            difficulty: {
                0: '低',
                1: '中',
                2: '高',
            },
        }
        return values[type][key]
    }

    //选择题目分类按钮事件
    addCategoryEvent = () => {
        this.setState({
            dynamicWizTableInfo: [],
            categoryModalFormVisible: true,
        });
    }
    //题目分类编辑
    editRow(item) {
        let info = {
            id: item.id || null,
            categoryIds: item.questionCategory,
            questionCategoryTitle: item.questionCategoryTitle,
            questionCategory: [{ value: item.categoryIds, title: item.questionCategoryTitle, key: item.categoryIds, parentTitle: item.questionCategoryTitle }],
            type: item.type,
            difficulty: item.difficulty,
            size: item.size,
        }
        this.setState({
            dynamicWizTableInfo: info,
            categoryModalFormVisible: true
        })
    }
    //题目分类删除
    deleteDynamicRow(record) {
        const { categoryTabelForm, questionAllNum } = this.state;
        let forms = [];
        categoryTabelForm.forEach(e => {
            if (e['key'] !== record.key) {
                forms.push(e);
            } else if (e['id'] !== record.id) {
                forms.push(e);
            }
        });
        this.setState({
            categoryTabelForm: forms,
            questionAllNum: questionAllNum - record['size']
        })

    }

    /**
     * 获取表单模态框属性（添加随机抽题章节内容）
     */
    _getModalDynamicProps = (record, visible, rows) => {
        return {
            title: '选择题目分类',
            record,
            rowKey: "id",
            showNum: false,
            selectType: "checkbox",
            isScroll: false,
            visible: visible,
            columns: dynamicWizModalFormColumns(this, record),
            modalOpts: {
                width: 600
            },
            onCancel: () => {
                this.setState({
                    categoryModalFormVisible: false
                });
            },
            onSubmit: values => {
                const { categoryTabelForm } = this.state
                let copyForm = Object.assign([], this.state.categoryTabelForm)
                let inArray = false
                let copyInfo = {
                    key: categoryTabelForm.length,
                    categoryIds: values['questionCategory'][0]['value'],
                    id: values.id,
                    size: this.size,
                    type: values.type,
                    typeTitle: this._getValue('type', values.type),
                    difficulty: values.difficulty,
                    difficultyTitle: this._getValue('difficulty', values.difficulty),
                    questionCategoryTitle: values['questionCategory'][0]['parentTitle'],
                    questionCategory: values['questionCategory'],
                }
                if (!this.size) {
                    wizNotice.error('该题目分类题型难度下没有题目，请重新选择')
                    return false;
                }
                //新增
                if (!values.id) {
                    for (let i = 0; i < copyForm.length; i++) {
                        //题目分类与题型相同的情况
                        if (copyForm[i]['categoryIds'] == values['questionCategory'][0]['value']
                            && copyForm[i]['type'] == values['type'] && copyForm[i]['difficulty'] == values['difficulty']) {
                            wizNotice.error('同一题目分类不能存在相同的题型')
                            return false;
                        }
                    }
                    copyInfo = { ...copyInfo, key: copyForm.length }
                    inArray = false
                    //修改
                } else {
                    for (let i = 0; i < copyForm.length; i++) {
                        //题目分类与题型相同的情况
                        if (values['id'] != copyForm[i]['id']) {
                            if (copyForm[i]['categoryIds'] == values['questionCategory'][0]['value']
                                && copyForm[i]['type'] == values['type'] && copyForm[i]['difficulty'] == values['difficulty']) {
                                wizNotice.error('同一题目分类不能存在相同的题型')
                                return false;
                            }
                        } else {
                            copyForm[i] = copyInfo
                            inArray = true
                        }
                    }
                }
                if (!inArray) {
                    copyForm.push(copyInfo);
                }
                let questionAllNum = 0
                if (Array.isArray(copyForm) && copyForm.length) {
                    const sizes = copyForm.map(item => item.size);
                    questionAllNum = sizes.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                }
                this.setState({
                    categoryTabelForm: copyForm,
                    categoryModalFormVisible: false,
                    questionAllNum: questionAllNum
                });
            }
        };
    }

    _handleQuestionNumChange = (e) => {
        this.setState({ questionNum: e });
    }

    _renderDynamicTable() {
        const { categoryModalFormVisible, record, categoryTabelForm, dynamicWizTableInfo, practiceInfo, questionAllNum, questionNum } = this.state;
        let message = (<React.Fragment>
            <span className="tips-font">共{questionAllNum || 0}题
                <text className="message-font">【仅能选择单选题、多选题、判断题】</text>
            </span> </React.Fragment>);
        return (
            <>
                <div>
                    <WizRow className='dynamic-row'>
                        <WizCol className='col-left'>练习周期：{practiceInfo.days}</WizCol>
                    </WizRow>
                    <WizRow className='dynamic-row'>
                        <WizCol className='col-left'>
                            <font className='font'>*</font>
                            每日抽题数量：
                            <WizInputNumber placeholder="请输入每日抽题数量"
                                min={1} max={120}
                                style={{ width: '200PX' }}
                                value={questionNum || null}
                                onChange={event => this._handleQuestionNumChange(event)}
                            />
                        </WizCol>
                    </WizRow>
                    <WizButton
                        icon="plus"
                        type="primary"
                        onClick={() => this.addCategoryEvent()}
                        className='addCategoryButton'
                    >
                        选择题目分类
                    </WizButton>
                    <WizAlert
                        type="info"
                        message={message}
                        showIcon
                        style={{ marginTop: 15 }}
                    />
                </div>
                <WizModalForm {...this._getModalDynamicProps(dynamicWizTableInfo, categoryModalFormVisible, 0)} />
                <div>
                    <WizTable columns={dynamicWizTableColumns(this)}
                        dataSource={categoryTabelForm} />
                </div>
            </>)
    }

    _render() {
        return (
            <div className='practice-out-body'>
                {this._renderDynamicTable()}
                <WizSpin tip={'加载中'} spinning={this.props.practiceLoading}>
                    <WizRow className='practice-button-row'>
                        <WizCol>
                            <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>
                            <WizButton title='保存并进入下一步' type='primary' onClick={this._saveAndNext}>保存并进入下一步</WizButton>
                            <WizButton title='保存并返回' onClick={this._saveAndBack}>保存并返回</WizButton>
                            <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
                        </WizCol>
                    </WizRow>
                </WizSpin>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => {
    const { practice } = state
    let { practiceId } = ownProps
    const practiceRule = modelUtils.getModelEntity(practice, "getRuleInfoById");
    const createRule = modelUtils.getModelEntity(practice, 'createRule_' + practiceId)
    const updateRule = modelUtils.getModelEntity(practice, 'updateRule_' + practiceId)
    const practiceInfo = modelUtils.getModelEntity(practice, 'getBaseInfoById')
    const load = modelUtils.getLoadingState(state, ['practice'])
    return {
        createRule,
        updateRule,
        practiceRule,
        practiceInfo,
        ...load
    }
}

export default connect(mapStateToProps)(PracticeRule)